<template>
  <div>
    <headers></headers>
    <!--<carousel></carousel>-->
    <p class="banner padding88"><img :src="sliderImg" alt="" height="200px" width="100%"></p>
<!--    <div class="divider ">-->
<!--      <div class="auto">-->
<!--        <router-link to="/">首页</router-link><span>></span>技能认定-->
<!--      </div>-->
<!--    </div>-->
    <div class="navs">
      <div class="auto">
        <div class="title">
          <div class="pull-l">
            <div class="nav-item"   @mouseenter="showSubMenu(0)"
                 @mouseleave="hideSubMenu(0)">
              <ul class="parent-menu">
            <li :class="{active:0===nowIndex}"  @click="tab('jnrd-2', 0)"><router-link to="/jnrd2" class="font14">物业管理师职业技能等级认定培训▼</router-link></li>
              <span class="arrow" :class="{active: expandIndex === 0}"></span>
              </ul>
            <!-- 二级菜单 -->
            <ul class="submenu" v-show="expandIndex === 0">
              <li :class="{active:0===nowIndex}" @click="tab('jnrd-2', 0)">
                <router-link to="/jnrd2" class="font14">项目介绍</router-link>
              </li>
              <li :class="{active:3===nowIndex}" @click="tab('jnrd-3', 3)">
                <router-link to="/jnrd3" class="font14">报考流程</router-link>
              </li>
              <li :class="{active:4===nowIndex}" @click="tab('jnrd-4', 4)">
                <router-link to="/jnrd4" class="font14">证书查询</router-link>
              </li>
            </ul>
            </div>
            /
            <li :class="{active:1===nowIndex}"  @click="tab('jnrd-5', 1)"><router-link to="/jnrd5" class="font14">物业管理项目经理培训</router-link></li>
<!--            <li :class="{active:0===nowIndex}"  @click="tab('jnrd', 0)"><router-link to="/skill" class="font14">勤博培训中心介绍</router-link></li>/-->
<!--            <li :class="{active:1===nowIndex}"  @click="tab('jnrd-2',1)"><router-link to="/jnrd2" class="font14">项目介绍</router-link></li>/-->
<!--            <li :class="{active:2===nowIndex}"  @click="tab('jnrd-3',2)"><router-link to="/jnrd3" class="font14">报考流程</router-link></li>/-->
<!--            <li :class="{active:3===nowIndex}"  @click="tab('jnrd-4',3)"><router-link to="/jnrd4" class="font14">证书查询</router-link></li>-->
          </div>
        </div>
      </div>
    </div>
        <div class="index_search" v-if="nowIndex===4">
          <div class="clearfix">
            <span class="pull-left label">结业证书查询</span>
            <div class="searchOut pull-left" >
              <Input prefix="ios-search" placeholder="请输入身份证号查询" v-model="certificateNum" class="inputSearch" size="large"/>
              <span class="searchBtn"  @click="searchCertificate()">查询</span>
            </div>
          </div>
          <el-dialog   title="证书查询"
                       :visible.sync="cerSearchShow"
                       v-if="cerSearchShow"
                       top="40vh"
                       width="110vh"
                       :append-to-body="true"
                        @close="dialogClose"
          >
            <h3>{{cerRemark}}</h3>
            <div  class="row-con" >
                <el-card :body-style="{ padding:'10px' }" v-for="item in certificateList" style=" width:350px; ">

                  <h3> <img  src="../../assets/icon.png"  align="left" alt="">{{item.certificateName}}</h3>
                    <li >
                      <span>持 证 人 &nbsp;：</span>{{ item.userName }}
                    </li>
                  <li><span>证书编号：</span>{{ item.certificateNum }}</li>
                  <li><span>发证机构：</span>{{ item.award }}</li>

                  <ul>
                    <!-- class="pull-left" -->
                    <li><span>发证时间：</span>{{ item.awardTime }}</li>
                    <!--              <li><span>有效期至：</span>{{ item.validity }}</li>-->
                  </ul>

                  <el-button style="float: right; padding: 5px 0" type="text" @click="downloadCer(item.certtificateImage,item.certificateName,item.idCard)">下载证书</el-button>
                </el-card>
            </div>

            <span slot="footer" class="dialog-footer"> </span>
          </el-dialog>
        </div>
    <div class="auto padding250 content-wrap">
      <div class="auto">
        <div class="container clearfix content-area font14" v-html=html style="text-align: left;">
        </div>

    </div>
      <Spin  v-show="isSpinShow">
        <div class="loader">
          <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
          <div class="font14">加载中...</div>
        </div>
      </Spin>
    </div>
    <asides></asides>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
/* 一级菜单项样式 */
.nav-item {
  position: relative;
  display: inline-block; // 保持一级菜单横向排列
}
.parent-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* 二级菜单样式 */
.submenu {
  position: absolute;
  display: block; /* 重要：确保显示 */
  top: 100%;
  left: 0;
  list-style: none;
  margin: 10px;
  padding: 8px 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 999; /* 确保二级菜单在最上层 */
 width: 200px;
}

.submenu li {
  padding: 6px 16px;
  cursor: pointer;
  /* 核心：每个菜单项独占一行 */
  display: block;
  flex-direction: column;

}

.submenu li:hover {
  background-color: #f3f4f6; /* hover高亮 */
  display: block;
  flex-direction: column;
}

.submenu li:hover a {
  color: #957960 !important; /* 金色文字，优先级拉满 */
  font-weight: bold; /* 可选：加粗更醒目 */
}

.submenu li .font14 {
  text-decoration: none;
  color: #999;
  display: block;
  flex-direction: column
}

/* 激活态样式（保持和原有一致） */
.active {
  color: #165dff; /* 示例激活色，可根据你的项目调整 */
  font-weight: 500;

}

/* 重置router-link默认样式 */
.font14 {
  text-decoration: none;
  color: #999;
  font-size: 14px;
}
  /* 旋转效果 */
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50% { transform: rotate(180deg);}
    to { transform: rotate(360deg);}
  }
  /* 假如内容过长，一屏放不下，滚动条下拉覆盖不全 */
  .ivu-spin-fix {
    position: fixed;
  }
  .index_search{
  //  background-color: #fff;
  //  box-shadow:0 3px 7px rgba(204,204,204,0.3);
    padding-right: 10px;
    width: 500px;
    margin-bottom: 10px;
    margin-left: auto; /* 自动左边距，推向右对齐 */
    margin-right: 200px; /* 距离右边20px */
    .clearfix{
     // margin: auto;
      margin-right: 10px;
      width: 500px;
    }
    .label{
      color: #000;
      font-size: 20px;
      margin:3px 20px 0 0;
    }
    .searchOut{
      width: 350px;
      height: 32px;
      display: table;
      overflow: hidden;
      border: 1px solid #957960;
      border-radius: 3px;
      .ivu-input{
        display: table-cell;
        border: 1px solid #957960;
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #333;
        padding: 0 15px 0 5px;
      }

      .searchBtn{
        display: table-cell;
        width: 1px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        line-height: 30px;
        white-space: nowrap;
        padding: 0 15px;
        background-color: #957960;
        cursor: pointer;
        &:active{
          background-color: darken(#957960,3%);
        }
      }
    }
  }
  .divider{
    height: 53px;
    background-color: #fff;
    font-size: 14px;
    color: #957960;
    line-height: 53px;
    text-align: left;
    margin-bottom: 30px;
    box-shadow: 5px 1px 10px #ccc;
    a{
      color: #957960;
      &:hover{
        color: #9C7649;
        font-weight: 700;
      }
    }
    span{
      margin: 0 10px;
    }
  }
  form{
    width: 360px;
    margin:50px  0 0 50px ;
  }

  .navs{
    background-color: #fff;
    box-shadow: 5px 1px 10px #ccc;
    margin-bottom: 50px;

  }
  pull-l{
    margin-left: 5px;
    li:last-child{
      font-size: 14px;
      margin-top: 10px;
      img{
        vertical-align: sub;
      }
      a{
        color: #0089c4;

      }
    }
  }
  .title{
    font-size: 18px;
    color: #000;
    padding: 10px 41px;
    text-align: left;
    li{
      display: inline-block;
      margin-right: 10px;
      a{
     //   padding: 5px 5px 15px;
        font-size: 18px;
        color: #666666;
      }
    }
    li.active {
      a{
        font-weight: 700;
        color: #957960;
       // background-color: #957960;
       // padding:10px 20px;
        //border-bottom: 3px solid #957960;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }


  //.title{
  //  font-size: 20px;
  //  color: #000;
  //  margin: 20px 0 25px 0;
  //  text-align: left;
  //  padding: 15px 20px ;
  //  background-color: #fff;
  //}
  .sex .ivu-form-item-content{
    text-align: left;
  }
  .ceping_form .ivu-date-picker{
    width: 250px;
  }
  .container {
    background-color: #fff;
    padding: 0px 41px;
    line-height: 30px;
  }
  /* 关键修改4：内容区样式调整 */
  .content-wrap {
    width: 100%;
  }
  .content-area {
    background-color: #fff;
    padding: 0px 41px;
    line-height: 30px;
    min-height: 600px; /* 新增：防止内容区高度为0时蒙层看不见 */
    position: relative; /* 核心：作为蒙层的定位参考 */
    margin:50px auto;
  }

  /* 关键修改5：加载蒙层样式，仅覆盖content-area */
  .content-loading {
    position: absolute; /* 绝对定位 */
    magin-top:  5px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8); /* 半透明白色遮罩 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10; /* 确保蒙层在内容上方 */
  }
  /* 加载动画容器样式优化 */
  .loader {
    background: #fff;
    padding: 20px 40px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  /* 移除原有的全屏fixed样式 */
  /deep/ .ivu-spin-fix {
    position: static !important;
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
  import carousel from '../template/carousel'
  import {getStore} from "../../storage";
  import {centreInfoWeb, getHtmlWeb, searchByNum, downCertifite, sliderPC} from '../../http'
  import asides from "../template/aside.vue";
  export default {
    name: '',
    props: {},
    data() {
      return {
        nowIndex:0,           //视频类别选择
        html:'',
        sliderImg:'',
        isSpinShow:false,
        certificateList:[],
        certificateNum: '',//证书编号
        expandIndex: -1, // 控制二级菜单展开：-1收起，0展开职业技能的二级菜单
        timer: null, // 新增：定义timer变量，避免悬浮时报错
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(newRoute) {
          // 从路由路径中提取tab标识（如 college、college2 等）
          const tabKey = newRoute.path.split('/').pop();
          // 映射tabKey到对应的索引
          const tabIndexMap = {
            'jnrd': 0,
            'jnrd2': 0,
            'jnrd3': 3,
            'jnrd4': 4,
            'jnrd5': 1
          };
          this.nowIndex = tabIndexMap[tabKey] || 0;
          this.loadContent(tabKey);
        }
      }
    },
    methods: {
      // 显示指定的二级菜单（清除延迟定时器）
      showSubMenu(index) {
        clearTimeout(this.timer);
        this.expandIndex = index;
      },
      // 隐藏指定的二级菜单（增加200ms延迟，避免快速移开误触发）
      hideSubMenu(index) {
        this.timer = setTimeout(() => {
          if (this.expandIndex === index) {
            this.expandIndex = -1;
          }
        }, 200);
      },
      //关闭dialog
      dialogClose(){
        this.certificateNum='';
        this.certificateList=[];
      },
      downloadCer(url,name,idCard){
        let replaceUrl = url.replace('http','https');
        const link = document.createElement('a');
        // 这里是将链接地址url转成blob地址，
        fetch(replaceUrl).then(res => res.blob()).then(blob => {
          link.href = URL.createObjectURL(blob)
          // 下载文件的名称及文件类型后缀
          //  link.download =name+parseInt(new Date().getTime() / 1000) + ''+".pdf";
          link.download =name+idCard+".pdf";

          document.body.appendChild(link)
          link.click()
          //在资源下载完成后 清除 占用的缓存资源
          window.URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        });


      },
      searchCertificate(){
        let that = this
        this.isSpinShow = true;
        if(this.certificateNum == ''){
          this.isSpinShow = false;
          this.$Notice.warning({
            title: '证书查询提醒',
            desc: '请输入身份证号查询'
          });
          return;
        }

          searchByNum({certificateNum : that.certificateNum}).then(res => {
            console.info(res)
            that.isSpinShow = false;
            that.cerSearchShow = true;
            if(res.data){
              console.log("证书结果",res.data)
              if (res.data.length===0){
                //没有证书
                that.cerRemark="对不起，您未完成规定的课时学习，请您确认学习进度，尽快完成学习任务。"
              }else{
                that.cerRemark="恭喜您参加物业管理师四（三、二、一）级培训，获取结业证书！"
                that.certificateList = res.data;
              }
              // downCertifite({userCertifiId: res.data.id, userId: res.data.userId}).then(res => {
              //   console.info(res)
              //   that.content = res.replace("../", "http://www.cbstudy.com/base/")
              //   that.modal1 = true
              //   that.modal = false
              // })
            }else{
              that.modal = true
              that.modal1 = false
              return;
            }
          ;
        })
      },

      loadContent(tabKey) {
        // 映射tabKey到后端需要的type值
        const typeMap = {
          'jnrd': 'jnrd',
          'jnrd2': 'jnrd-2',
          'jnrd3':'jnrd-3',
          'jnrd4':'jnrd-4',
          'jnrd5':'jnrd-5'

        };
        const type = typeMap[tabKey] || 'jnrd2';
        this.getZhuanhuan(type);
      },
      loadBanner(){
        //获取封面图
        sliderPC({sliderType:'14'}).then(res =>{
          this.sliderImg = res.data.slider.sliderImg;
        }).catch()
      },
      getZhuanhuan(type) {
        if (this.isSpinShow === false) {
          this.isSpinShow = true;
          //获取页面
          getHtmlWeb({type: type}).then(res => {
            this.isSpinShow = false;
            this.html = res.data.html.htmlContent;
          }).catch()
        }
      },

      //课程排序切换
      tab(type,index){
        this.nowIndex = index;
        this.sortOrder = 'S' + index;
        this.pageNumber = 1;
        this.getZhuanhuan(type);
      },
    },
    created() {
      this.loadBanner();
      this.getZhuanhuan('jnrd2')
    },
    components: {
      asides,
      headers,
      footers,
      carousel
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/other/skill.vue